export default __webpack_public_path__ + "static/media/no-pin.48aa9b9b.svg";